import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { Button, Stack } from '@mui/material';
import { useNavigate } from 'react-router';
import NearbyErrorIcon from '@mui/icons-material/NearbyError';

import { isValidToken } from 'utils';
import { LINKS } from 'constants/links';
import theme from 'theme';

const Error = () => {
	const isAuth = isValidToken();
	const navigate = useNavigate();

	const handleBack = () => {
		navigate(isAuth ? LINKS.DASHBOARD : LINKS.LOGIN, { replace: true });
	};

	return (
		<Container sx={{ mt: 6 }}>
			<Stack spacing={2} justifyContent="center" alignItems="center">
				<NearbyErrorIcon sx={{ fontSize: '10rem', fill: theme.palette.secondary.main }} />
				<Typography variant="h4" textAlign="center" fontWeight="bold">
					Oops! An error occured.
					<br /> Please try again later.
				</Typography>
				<Typography>If the issue persists please contact us.</Typography>
				<Button variant="contained" color="secondary" onClick={handleBack}>
					Back to {isAuth ? 'Dashboard' : 'Login'}
				</Button>
			</Stack>
		</Container>
	);
};

export default Error;
